<template>
  <div class="regulatory-update-verify-password">
    <Modal title="" is-open size="md" @close="close">
      <HeadingDisplay
        size="small"
        title="Digite sua senha para continuar"
        class="regulatory-update-verify-password__title"
      />
      <SingleInput
        v-model="password"
        placeholder="Senha da conta"
        type="password"
        class="regulatory-update-verify-password__input"
        :helper-text="helperText"
        :status="inputStatus"
        @change="inputBlur"
      />
      <template #buttonContainer>
        <ButtonContainer mobile-direction="VERTICAL">
          <ButtonPrimary
            slot="button-primary"
            label="Continuar"
            @click="sendVerifyPassword"
          />
          <ButtonSecondary
            slot="button-secondary"
            label="Cancelar"
            @click="close"
          />
        </ButtonContainer>
      </template>
    </Modal>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Vue } from 'vue-property-decorator';
import {
  Modal,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  HeadingDisplay,
  SingleInput
} from '@warrenbrasil/nebraska-web';
import {
  goToPreviousRoute,
  goToNextRoute
} from '@/modules/common/store/RegulatoryUpdateRoutesOrchestrator';
import { verifyPassword } from '../../services';
import { InputStatusType } from '../../types';
import {
  trackCancel,
  trackContinue,
  trackError,
  trackView
} from './track-events';

@Component({
  components: {
    Modal,
    ButtonContainer,
    ButtonPrimary,
    ButtonSecondary,
    HeadingDisplay,
    SingleInput
  }
})
export default class RegulatoryUpdateVerifyPassword extends Vue {
  @Emit()
  private setIsLoading(_isLoading: boolean) {}

  public password = '';

  private isPasswordInvalid = false;

  mounted() {
    this.setIsLoading(false);
    trackView();
  }

  public close() {
    trackCancel();
    goToPreviousRoute();
  }

  public get helperText() {
    return this.isPasswordInvalid ? 'Senha inválida' : '';
  }

  public get inputStatus() {
    return this.isPasswordInvalid
      ? InputStatusType.Error
      : InputStatusType.Default;
  }

  public inputBlur() {
    this.isPasswordInvalid = false;
  }

  private get cameFromRoute(): string {
    return this.$route.query.cameFrom as string;
  }

  public async sendVerifyPassword() {
    try {
      await verifyPassword(this.password);

      trackContinue();

      if (this.cameFromRoute) {
        this.$router.push({ name: this.cameFromRoute });
        return;
      }

      goToNextRoute();
    } catch {
      this.isPasswordInvalid = true;
      trackError('Senha inválida');
    }
  }
}
</script>

<style lang="less" scoped>
.regulatory-update-verify-password {
  &__title {
    width: 100%;
    text-align: left;
    margin-bottom: @size-spacing-x800;
  }

  &__input {
    text-align: left;
  }

  & /deep/ .modal-content {
    padding-top: 0;
  }
}
</style>
